import React, { useState, useEffect } from "react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import Loader from '../components/Loader'

const Privacypolicy = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;

  const [data, setData] = useState('');
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const apiUrl = apiBaseUrl+`privacypage`;

  function createMarkup(data) {
    return { __html: data };
  }  

  const fetchInfo = () => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.page)
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);      
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })

  return (
    <>
    <Header/>
    { loading && (<Loader /> )}	
    <section className="section-content-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="about-us-intro">
                            <p className="blue">{data?.name}</p>
                            <h2 className="heading">{data?.page_heading}</h2>
                          	<p>{data?.short_description}</p> 
                        </div>                            
                    </div> 
					
                </div>
				
				<div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="Products">
                          {data?.image && (
                            <img src={`${siteUrl}${data?.image}`} alt={data?.name} /> 
                          )}
							            
                        </div>                            
                    </div> 

                </div>
            </div> 
    </section>
		
	<div className="container"><hr/></div>
		
	<section className="section-content-block TopCon">
		<div className="container">
			<div className="row">
				<div className="col-lg-12 col-md-12 col-sm-12 ">                       
					<div className="terms" dangerouslySetInnerHTML={createMarkup(data?.description)}></div>
				</div> 
			</div>
		</div> 
	</section>

    <Footer/>
    </>

  )
}

export default Privacypolicy